/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type UserGroupOptionFragment = {
  __typename?: 'BackofficeUserManagementGroup'
  critical: boolean
  gdpr: boolean
  name: string
  displayName: string
  assignedOrganizations: Array<string> | null
}

export const UserGroupOptionFragmentDoc = gql`
    fragment UserGroupOption on BackofficeUserManagementGroup {
  critical
  gdpr
  name
  displayName
  assignedOrganizations
}
    `
